import "core-js/modules/es.array.push.js";
import { getTokens } from "@/js/consent";
export default {
  name: "consent",
  data: function data() {
    return {
      code: "",
      state: "",
      first_connection: "",
      stateError: "",
      errorMessages: {
        state: {
          different: "Disparities in the verification code of the request. Please contact an administrator as soon as possible"
        }
      }
    };
  },
  created: function created() {
    this.code = this.$route.params.code;
    this.state = this.$route.params.state;
    this.first_connection = this.$route.params.first_connection;
    if (this.$route.params.consent) {
      // if the consent has already been given by the user, we already redirect him to his home page
      getTokens(this, this.code, this.state, this.first_connection);
    }
  },
  methods: {
    toLogin: function toLogin() {
      this.$router.push({
        name: "login"
      });
    },
    connect: function connect() {
      getTokens(this, this.code, this.state, this.first_connection);
    }
  }
};